<template>
  <div class="grid grid-cols-5 w-full mx-auto py-2 px-3" v-bind:class="{'pointer-events-none': currentView === 'map'}">
    <div class="text-gray-400 mx-auto text-sm flex items-center" v-bind:class="{ 'viewed-event': event.isViewedByUser }">
      <img src="/img/myle/svg/eye.svg" alt="" class="mr-2 h-4">
      <p>{{ event.totalViewsCount }}</p>
    </div>

    <div v-on:click="attendingClicked" v-bind:class="{ 'pointer-events-none': !attendingEvents, 'attended-event': event.isAttendingByUser }"
        class="e-attending text-gray-400 mx-auto text-sm flex items-center">
      <img :src="(event.isAttendingByUser && highlightattend) ? '/img/myle/svg/attendred.svg' : '/img/myle/svg/ic_lowerbarAttending.svg'" alt="" v-bind:class="{ 'pointer-events-none': !attendingEvents, 'attended-event': event.isAttendingByUser }" class="mr-2 h-4 cursor-pointer">
      <p>{{ event.totalAttendingsCount }}</p>
    </div>

    <div v-on:click="loveClicked" v-bind:class="{ 'pointer-events-none': !lovedEvents, 'loved-event': event.isLovedByUser }"
         class="text-gray-400 mx-auto text-sm flex items-center e-loved">
      <img :src="(event.isLovedByUser && highlightlove) ? '/img/myle/svg/lovered.svg' : '/img/myle/svg/ic_lowerbarLoved.svg'" alt=""  v-bind:class="{ 'pointer-events-none': !lovedEvents, 'loved-event': event.isLovedByUser }" class="mr-2 h-4 cursor-pointer">
      <p>{{ event.totalLovedCount }}</p>
    </div>

    <div v-on:click="likeClicked" v-bind:class="{ 'pointer-events-none': !likedEvents, 'liked-event': event.isLikedByUser }"
         class="text-gray-400 mx-auto text-sm flex items-center e-liked">
      <img :src="(event.isLikedByUser && highlightlike) ? '/img/myle/svg/likered.svg' : '/img/myle/svg/ic_lowerBarLiked.svg'" v-bind:class="{ 'pointer-events-none': !likedEvents, 'liked-event': event.isLikedByUser }" alt="" class="mr-2 h-4 cursor-pointer">
      <p>{{ event.totalLikesCount }}</p>
    </div>

    <div class="text-gray-400 mx-auto text-sm flex items-center ">
      <img src="/img/myle/svg/ic_tileChatGrey.svg" alt="" class="mr-2 h-4 cursor-pointer">
      <p>{{ event.totalCommentCount }}</p>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "event-stats",
  props: {
    attendingEvents: {
      type: Boolean,
      default: false
    },
    lovedEvents: {
      type: Boolean,
      default: false
    },
    likedEvents: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: {},
    },
    extraClass: {
      type: String,
      default: "",
    },
    authenticated: {
      type: Boolean
    },
    highlightattend: {
      type: Boolean,
      default: false
    },
    highlightlove: {
      type: Boolean,
      default: false
    },
    highlightlike: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions('events', ['likEvent', 'unLikeEvent', 'loveEvent', 'unLoveEvent', 'attendEvent', 'unAttendEvent']),
    attendingClicked(e) {
      e.preventDefault(); e.stopPropagation();
      if(this.event.isAttendingByUser) {
        this.unAttendEvent({
          userId: this.user.userRefId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude
        });
      } else {
        this.attendEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius
        });
      }
    },
    loveClicked(e) {
      e.preventDefault(); e.stopPropagation();
      if(this.event.isLovedByUser) {
        this.unLoveEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius
        });
      } else {
        this.loveEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius
        });
      }
    },
    likeClicked(e) {
      e.preventDefault(); e.stopPropagation();
      if(this.event.isLikedByUser) {
        this.unLikeEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius
        });
      } else {
        this.likEvent({
          userId: this.user.userId,
          eventId: this.event.eventCode,
          latitude: this.user.latitude,
          longitude: this.user.longitude,
          miles: this.user.radius
        });
      }
    }
  },
  computed: {
    ...mapState("account", ["user"]),
    ...mapState('events', ['currentView']),
  }
};
</script>
<style>
  .disabled-stats li a {
    pointer-events: none;
  }

  .pointer-events-none {
    pointer-events: none;
  }
</style>
